<div class="logo" [ngClass]="{'business-user': isBusinessUser}">
    <a class="mobile" [href]="url" (click)="closeNav()">
        <xm-media-image [imageOptions]="imageOptions" size="width"></xm-media-image>
    </a>
    <a class="desktop" [href]="url">
        <xm-media-image [imageOptions]="imageOptions" size="width"></xm-media-image>
    </a>
</div>
